import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ContactUsPage = () => {
  const { t } = useTranslation();
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: '',
    honeypot: '', // Hidden field for bot detection
  });
  const [formLoadTimestamp, setFormLoadTimestamp] = useState(0);
  const [status, setStatus] = useState(''); // For loading/error messages
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setFormLoadTimestamp(Date.now());
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(t('app.contact.status.sending'));

    const dataToSend = {
      ...formState,
      formLoadTimestamp,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/submissions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        setIsSubmitted(true);
      } else {
        const errorText = await response.text();
        setStatus(t('app.contact.status.errorWithDetails', { errorText }));
      }
    } catch (error) {
      console.error('Submission error:', error);
      setStatus(t('app.contact.status.error'));
    }
  };

  if (isSubmitted) {
    return (
      <div style={{ padding: '20px', maxWidth: '600px', margin: '40px auto', textAlign: 'center' }}>
        <h1 style={{ marginBottom: '20px' }}>{t('app.contact.thankYou')}</h1>
        <p style={{ marginBottom: '30px' }}>{t('app.contact.status.success')}</p>
        <button 
          onClick={() => navigate('/')}
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          {t('app.contact.backToMenu')}
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '40px auto', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>{t('app.contact.title')}</h1>
      <p style={{ textAlign: 'center', marginBottom: '30px' }}>{t('app.contact.description')}</p>
      
      <form onSubmit={handleSubmit}>
        {/* Honeypot field, hidden from users */}
        <input
          type="text"
          name="honeypot"
          value={formState.honeypot}
          onChange={handleChange}
          style={{ display: 'none' }}
          autoComplete="off"
        />

        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="name" style={{ display: 'block', marginBottom: '5px' }}>{t('app.contact.nameLabel')}</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formState.name}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="email" style={{ display: 'block', marginBottom: '5px' }}>{t('app.contact.emailLabel')}</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formState.email}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="message" style={{ display: 'block', marginBottom: '5px' }}>{t('app.contact.messageLabel')}</label>
          <textarea
            id="message"
            name="message"
            value={formState.message}
            onChange={handleChange}
            required
            rows="5"
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          ></textarea>
        </div>

        <button type="submit" style={{ width: '100%', padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          {t('app.contact.submitButton')}
        </button>
      </form>

      {status && <p style={{ marginTop: '20px', textAlign: 'center' }}>{status}</p>}
    </div>
  );
};

export default ContactUsPage;